import Vue from 'vue';
import {
    QUEUE_MANAGEMENT_ENDPOINTS,
    FLOW_COLLECTION_TYPES,
} from '../utils/constants';
import { storeGet } from '@/store/store-utils';

export default {
    namespaced: true,

    state: {
        queueDataList: [],
        tableLoading: false,
        loading: false,
    },

    getters: {
        queueDataList: (state) => state.queueDataList,
        tableLoading: (state) => state.tableLoading,
        loading: (state) => state.loading,
    },

    mutations: {
        SET_QUEUE_DATA_LIST(state, data) {
            state.queueDataList = data;
        },
        SET_TABLE_LOADING(state, flag) {
            state.tableLoading = flag;
        },
        SET_LOADING(state, flag) {
            state.loading = flag;
        },
        RESET_STATE(state) {
            state.queueDataList = [];
            state.tableLoading = false;
            state.loading = false;
        },
    },

    actions: {
        async peekQueue({ commit, rootState }, { queueName, maxMessages = 10, deadLetter = false }) {
            commit('SET_TABLE_LOADING', true);
            try {
                const response = await storeGet(
                    Vue.axios, rootState,
                    QUEUE_MANAGEMENT_ENDPOINTS.PEEK,
                    { queueName, maxMessages, deadLetter }
                );
                if (response.data.status === 'success') {
                    commit('SET_QUEUE_DATA_LIST', response.data.data || []);
                } else {
                    throw new Error(response.data.message || 'Failed to peek queue');
                }
            } catch (error) {
                console.error('[QueueManagement Store]: peekQueue error', error);
                commit('sbError', error?.response?.data?.message || error?.message || `Failed to peek ${queueName}`, { root: true });
            } finally {
                commit('SET_TABLE_LOADING', false);
            }
        },

        async sendQueue({ commit, dispatch }, payload) {
            commit('SET_LOADING', true);
            try {
                const response = await Vue.axios.post(QUEUE_MANAGEMENT_ENDPOINTS.SEND, {
                    ...payload,
                    messages: typeof payload.messages === 'string' ? JSON.parse(payload.messages) : payload.messages,
                });
                if (response.data.status === 'success') {
                    commit('sbSuccess', 'Queue sent successfully', { root: true });
                    dispatch('peekQueue', { queueName: payload.queueName });
                    return true;
                } else {
                    throw new Error(response.data.message || 'Failed to send queue');
                }
            } catch (error) {
                console.error('[QueueManagement Store]: sendQueue error', error);
                commit('sbError', error?.response?.data?.message || error?.message || 'Failed to send queue', { root: true });
                return false;
            } finally {
                commit('SET_LOADING', false);
            }
        },

        async dispatchFlow({ commit }, flowObject) {
            const endpointMap = {
                [FLOW_COLLECTION_TYPES.TASK_STATE]: QUEUE_MANAGEMENT_ENDPOINTS.SILKROUTE_TASK_STATE,
                [FLOW_COLLECTION_TYPES.FLOW_STATE]: QUEUE_MANAGEMENT_ENDPOINTS.SILKROUTE_FLOW_STATE,
            };

            const endPoint = endpointMap[flowObject.collectionName];
            if (!endPoint) {
                commit('sbError', 'Invalid collection name', { root: true });
                return false;
            }

            commit('SET_LOADING', true); 
            try {
                const response = await Vue.axios.put(endPoint,  flowObject );
                if (response.data.status === 'success') {
                    commit('sbSuccess', 'Flow dispatched successfully', { root: true });
                    return true;
                } else {
                    throw new Error(response.data.message || 'Failed to dispatch flow');
                }
            } catch (error) {
                console.error('[QueueManagement Store]: dispatchFlow error', error);
                commit('sbError', error?.response?.data?.message || error?.message || 'Failed to dispatch flow', { root: true });
                return false;
            } finally {
                commit('SET_LOADING', false);
            }
        },
    },
};
